<div class="row col-12 p-0 m-0 contact-container main-page-section ">
  <div class="col-12 p-0">
    <!-- <app-header></app-header> -->
    <div class="contact-section ">
      <div class="col-12 p-0">
        <img src="../../assets/images/contact/contact-bg.png" alt="Contact Background Image" class="main-img"
          loading="lazy">
      </div>

      <div class="col-12 contact-details">
        <div class="title">Contact</div>
        <div class="address">
          {{contactDetails?.address.buildingName}}, {{contactDetails?.address.area}}, {{contactDetails?.address.city}} -
          {{contactDetails?.address.pinCode}}
        </div>
        <div class="divider"></div>
        <div class="call">
          <span class='sub-title'>Call us</span>
          <span> {{contactDetails?.call}}</span>
        </div>
        <div class="divider"></div>
        <div class='mail'>
          <span class='sub-title'>Mail us</span>
          <span> <a [href]="'mailto:'+contactDetails?.email"> {{contactDetails?.email}} </a></span>
        </div>
        <div class="divider"></div>
      </div>
    </div>
  </div>
</div>
